var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-card',{staticClass:"mt-1"},[_c('canvas',{attrs:{"id":"barChart","width":"400","height":"100"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }